import '../App.css';

import { UpdateIcon } from '@radix-ui/react-icons';

import { Button } from '../components/ui/button';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../components/ui/card";
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from '../components/ui/use-toast';

function Reset() {

    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [canSubmit, setCanSubmit] = useState(true);


    const sendResetRequest = (e) => {
        if (isLoading || !canSubmit) return;

        e.preventDefault();
        setIsLoading(true);
        setCanSubmit(false);

        axios.post('https://skhrf-api.cmdigital.se/v1/auth/reset-request', { email })
            .then(response => {
                toast({
                    title: 'Begäran skickad',
                    description: response.data.message + ' Du kan skicka ett nytt meddelande om 30s.',
                });
                setIsLoading(false);
            })
            .catch(error => {
                toast({
                    variant: 'destructive',
                    title: 'Något gick fel.',
                    description: error?.response?.data?.error[0],
                });
                setIsLoading(false);
                setCanSubmit(true);
            });
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setCanSubmit(true);
        }, 30000);

        return () => clearTimeout(timer);
    }, [canSubmit]);

    return (
        <div className='flex w-full h-screen items-center justify-center'>
            <Card className='w-3/4 lg:w-7/12 shadow-md'>
                <CardHeader>
                    <CardTitle>Återställ lösenord</CardTitle>
                    <CardDescription>Ange den e-post du använder för att logga in till STAMP.</CardDescription>
                </CardHeader>
                <CardContent className='grid gap-4'>
                    <div className='grid gap-2'>
                        <Label htmlFor="email">E-post</Label>
                        <Input id="email" type="email" autoComplete='email' placeholder="namn@exempel.se" required onChange={(e) => setEmail(e.target.value)} />
                    </div>
                </CardContent>
                <CardFooter>
                    <Button type="submit" className="w-full" disabled={isLoading || !canSubmit} onClick={sendResetRequest}>
                        {(isLoading) ? <UpdateIcon className='loader-spinner' /> : <>Återställ lösenord</>}
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
}

export default Reset;
